import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { START_EXAM, logError, setUIVisibilityState } from "../actions";
import { checkExamAttempts } from "../utils/helpers";
export default function onEvalInteractions(action$, state$) {
    return action$.pipe(ofType(START_EXAM), switchMap(function() {
        checkExamAttempts(state$.value);
        return [
            setUIVisibilityState({
                state: {
                    notes: false,
                    menu: false,
                    bonusMaterial: false,
                    activityCenter: false,
                    quickNav: false,
                    print: false,
                    modal: false
                }
            })
        ];
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "on_start_exam"
        }));
    }));
}
